import React, { useEffect, useState } from 'react';
import styles from '../index.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import repo from 'service/repository';
import LoadingDialog from 'components/loading-dialog';
import { PATH } from 'config';

const OrderDetailsPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { url } = qs.parse(location.search);
  const [blob, setBlob] = useState(null);
  const detailsButtonsShow = location.state?.from?.includes('bills') && !location.state.payAllBills;

  useEffect(() => {
    window.scrollTo(0, 0);
    repo.fetchOrderDetail(url).then(value => {
      setBlob(new Blob([value], { type: 'text/html' }));
    });
  }, []); //eslint-disable-line

  const Content = () => {
    if (blob === null) {
      return <LoadingDialog isShow={true} />;
    }
    return (
      <iframe
        id="orderDetailFrame"
        title="訂單明細"
        src={window.URL.createObjectURL(blob)}
        style={{
          display: 'block',
          width: '100%',
          height: detailsButtonsShow ? 'calc(100% - 77px)' : '100%',
          border: 'none',
          boxSizing: 'border-box',
        }}
      />
    );
  };

  const DetailsButtons = () => {
    return (
      <div className={styles['details-buttons']}>
        <div className={`${styles.button} ${styles.positive}`} onClick={() => history.goBack()}>
          繼續繳費
        </div>
        <div className={`${styles.button} ${styles.negative}`} onClick={() => history.push(PATH.MAIN)}>
          回主頁
        </div>
      </div>
    );
  };

  return (
    <div className={styles['order-details']}>
      {detailsButtonsShow && <DetailsButtons />}
      <Content />
    </div>
  );
};

export default OrderDetailsPage;
